module.exports = __webpack_public_path__ + "media/Loops 90 Bass.8873b179.wav";